<script lang="ts">
    import { twMerge } from 'tailwind-merge';

    export let rounded = false;
    export let name = '';

    const avatarBackgroundColorSet = ['#552F50', '#563997', '#1B64AE', '#345429', '#3D45AF', '#921475', '#725E19', '#155C82', '#1C255D', '#91451C'];

    // 사용자 이름에서 첫 글자(들) 추출
    $: initials = getInitials(name);
    $: backgroundColor = getBackgroundColor(name);

    function getInitials(fullName: string): string {
        if (!fullName) return '';

        const names = fullName.trim().split(' ');
        if (names.length === 1) {
            return names[0].charAt(0).toUpperCase();
        } else {
            return names
                .slice(0, 2)
                .map(n => n.charAt(0).toUpperCase())
                .join('');
        }
    }

    function getBackgroundColor(fullName: string): string {
        if (!fullName) return avatarBackgroundColorSet[0];

        // 이름의 해시값을 계산하여 색상 인덱스 생성
        let hash = 0;
        for (let i = 0; i < fullName.length; i++) {
            const char = fullName.charCodeAt(i);
            hash = (hash << 5) - hash + char;
            hash = hash & hash; // 32bit 정수로 변환
        }

        // 해시값을 배열 인덱스 범위로 변환
        const index = Math.abs(hash) % avatarBackgroundColorSet.length;
        return avatarBackgroundColorSet[index];
    }

    let svgClass: string;
    $: svgClass = twMerge('h-full w-full', rounded ? 'rounded' : 'rounded-full', $$props.class);
</script>

{#if name && initials}
    <!-- 이니셜 SVG -->
    <svg class={svgClass} viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
        <!-- 배경 -->
        {#if rounded}
            <rect width="100" height="100" rx="10" fill={backgroundColor} />
        {:else}
            <circle cx="50" cy="50" r="49" fill={backgroundColor} />
        {/if}

        <!-- 이니셜 텍스트 -->
        <text x="50" y="50" text-anchor="middle" dominant-baseline="central" fill="white" font-family="Arial, sans-serif" font-weight="400" font-size="42" class="select-none">
            {initials}
        </text>
    </svg>
{:else}
    <!-- 기본 아바타 아이콘 -->
    <svg width="44" height="44" viewBox="0 0 44 44" fill="none" xmlns="http://www.w3.org/2000/svg" class={twMerge('h-full w-full', $$props.class)}>
        <rect width="44" height="44" rx="22" fill="#E1E3EB" />
        <path
            d="M22.0327 21.9795C24.9265 21.9795 27.2725 19.6336 27.2725 16.7398C27.2725 13.8459 24.9265 11.5 22.0327 11.5C19.1389 11.5 16.793 13.8459 16.793 16.7398C16.793 19.6336 19.1389 21.9795 22.0327 21.9795Z"
            stroke="#8888A8"
            stroke-width="1.75"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M12.668 32.5V31.3333C12.668 26.1787 16.8466 22 22.0013 22C27.156 22 31.3346 26.1787 31.3346 31.3333V32.5"
            stroke="#8888A8"
            stroke-width="1.75"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
    </svg>
{/if}

<!--
  @component
  ## Features
  [Go to Avatar](https://flowbite-svelte.com/docs/components/avatar)
  @prop rounded: boolean = false;
  @prop name: string = '';
-->
